module.exports = __webpack_public_path__ + "img/greaseproof.60291235.jpeg";